export type JsonDiffEntry = {
  path: string;
  kind: "added" | "removed" | "changed";
  left?: unknown;
  right?: unknown;
};

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function diffJson(left: unknown, right: unknown, path = "$"): JsonDiffEntry[] {
  if (Object.is(left, right)) {
    return [];
  }

  if (Array.isArray(left) && Array.isArray(right)) {
    return Array.from({ length: Math.max(left.length, right.length) }, (_, index) => {
      const itemPath = `${path}[${index}]`;
      if (index >= left.length) {
        return [{ path: itemPath, kind: "added" as const, right: right[index] }];
      }
      if (index >= right.length) {
        return [{ path: itemPath, kind: "removed" as const, left: left[index] }];
      }
      return diffJson(left[index], right[index], itemPath);
    }).flat();
  }

  if (isRecord(left) && isRecord(right)) {
    return [...new Set([...Object.keys(left), ...Object.keys(right)])]
      .sort()
      .flatMap((key) => {
        if (key in left && key in right) {
          return diffJson(left[key], right[key], `${path}.${key}`);
        }

        return key in left
          ? [{ path: `${path}.${key}`, kind: "removed" as const, left: left[key] }]
          : [{ path: `${path}.${key}`, kind: "added" as const, right: right[key] }];
      });
  }

  return [{ path, kind: "changed", left, right }];
}
